export default {
  NO_HIDE: 'no_hide',
  HIDE_TOP: 'hide_top',
  HIDE_BOTTOM: 'hide_bottom',
  HIDE_BOTH: 'hide_both'
};